import { render } from "./TheLoginPage.vue?vue&type=template&id=cdfd3b5a&ts=true"
import script from "./TheLoginPage.vue?vue&type=script&lang=ts"
export * from "./TheLoginPage.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__